//comunity
import * as THREE from 'three'
import Tween from 'root/animator/tween/tween'
import Ease from 'root/animator/tween/easing'
import { dispatchSetChanging } from '../utils'
import { layers } from '../constants'
import { PointPass } from '../common/pointpass'
import lightMap from '../assets/light-8.png'

class Object8 {
    instance = new THREE.Group()

    sphereGroup = new THREE.Group()

    sphere
    sphereGeometry
    sphereMaterial

    stars
    starsGeometry
    starsMaterial

    bglight

    dirlight

    state = {
        visible: false,
        changing: false
    }

    position = {
        visible: [ 0, 0, 0 ],
        hidden: [ 0, -5, -8 ]
    }

    name = "SphereBottom"


    constructor( scene ) {
        this.generateSphere()
        this.generateStars()

        this.instance.visible = false

        this.dirlight = new THREE.DirectionalLight( new THREE.Color().setRGB(.08, .8, .6), 1. )
        this.dirlight.position.set( 0, 5, -10 )
        this.dirlight.layers.enable(layers.BLOOM_SCENE)

        this.instance.add( this.sphereGroup )
        this.instance.add( this.dirlight )

        this.sphereGroup.position.set( 0, -0.4, 0 )
        this.sphereGroup.scale.set( 2, 2, 2 )

        this.bglight = new BgLight( this.instance )

        this.instance.name = this.name

        this.instance.position.set(...this.position.hidden)

        scene.add( this.instance )
    }

    generateSphere() {
        this.sphereGeometry = new THREE.SphereBufferGeometry(2, 50, 50);


        this.sphereMaterial = new THREE.MeshStandardMaterial();
        this.sphereMaterial.color = new THREE.Color(0x020202)

        this.sphereMaterial.uniforms = {
            iTime: { value: 0 },
            iResolution: {
                value: {
                    x: window.innerWidth * window.devicePixelRatio,
                    y: window.innerHeight * window.devicePixelRatio
                }
            }
        };
        this.sphereMaterial.side = THREE.DoubleSide;
        this.sphere = new THREE.Mesh(this.sphereGeometry, this.sphereMaterial);
        this.sphere.name = "sphere"
        this.sphere.position.set(0, -2, 0);
        this.sphere.layers.enable(layers.BLOOM_SCENE)
        this.sphereGroup.add( this.sphere )
    }

    generateStars() {
        const starsShader = {
            uniforms: {
              iTime: { value: 0 },
              iResolution: { value: new THREE.Vector2() }
            },
            vertexShader: `
              attribute float size;
              uniform float iTime;
              uniform vec2 iResolution;
              varying vec3 col;
              varying float fade;
        
              #define SIZE 40.
          
              vec3 warp3d(vec3 pos, float t) {
                float curv = 0.9, a = 1.9, b = 0.003, c = 0.003;
                pos.x += curv * sin(c * t + a * pos.y) + t * b;
                pos.y += curv * cos(c * t + a * pos.x);
                pos.y += curv * sin(c * t + a * pos.z) + t * b;
                pos.z += curv * cos(c * t + a * pos.y);
                pos.z += curv * sin(c * t + a * pos.x) + t * b;
                pos.x += curv * cos(c * t + a * pos.z);
                return pos.xyz / 1.9;
              }
        
              vec3 warp3s(vec3 pos, float t) {
                float curv = 1.3, a = 1.9, b = 0.08, c = 0.05;
                pos /= 2.;
                pos.x += curv * sin(c * t + a * pos.y) + t * b;
                pos.y += curv * cos(c * t + a * pos.x);
                pos.y += curv * sin(c * t + a * pos.z) + t * b;
                pos.z += curv * cos(c * t + a * pos.y);
                pos.z += curv * sin(c * t + a * pos.x) + t * b;
                pos.x += curv * cos(c * t + a * pos.z);
                return cos(pos.xyz / 1.9 * 3.1415 + vec3(1,3,5));
              }
        
              vec4 qmult(vec4 p, vec4 q) {
                vec3 pv = p.xyz, qv = q.xyz;
                return vec4(p.w * qv + q.w * pv + cross(pv, qv), p.w * q.w - dot(pv, qv));
              }
        
              vec3 rotate(vec3 point, vec4 qrotor) {
                vec3 rv = qrotor.xyz;
                return qmult(qrotor, vec4(point * qrotor.w - cross(point, rv), dot(point, rv))).xyz;
              }
        
              vec2 wnoise2(vec2 pos, float t, float curv) {
                pos.x += curv * sin(2.0*t+1.5 * pos.y)+t*0.5;
                pos.y += curv * cos(2.0*t+1.5 * pos.x);
                return 0.5 + 0.5*cos(iTime+pos.xy+vec2(0,2));
              }
        
              vec3 hsv2rgb(vec3 c) {
                vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
                vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
                return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
              }
        
              void main() {
                col = position;
                vec3 v = position;
                vec3 w = warp3d(2. * v - 1., .85*iTime);
        
                float a = w.x * 6.2831853;
                float b = acos(2. * w.y - 1.);
                float r = pow(w.z, 1./3.);
                float x = r * sin(b) * cos(a);
                float y = r * sin(b) * sin(a);
                float z = r * cos(b);
                v = vec3(x, y, z);
                vec3 s = warp3s(v, .85*iTime);
                v = mix(v, s, 0.15);
        
                vec3 i = vec3(sin(5. * iTime * .005), sin( 7. * iTime * .005), sin(13. * iTime * .005)) * .5 + .5;
                vec4 q = vec4(sqrt(1. - 0.6 * i.x) * sin(6.2831853 * i.y), sqrt(1. - 0.6 * i.x) * cos(6.2831853 * i.y),
                              sqrt(0.6 * i.x) * sin(6.2831853 * i.z), sqrt(0.6 * i.x) * cos(6.2831853 * i.z));
        
                v = rotate(v.yxz, q);
                v = .988 * normalize(v);
                float fade = v.z * .35 + .65;
                v = 2. * (v - vec3(0, 1, 0));
        
                vec4 mvpos = modelViewMatrix * vec4(v, 1.);
                gl_PointSize = SIZE * size * iResolution.y / 730. / -mvpos.z;
                gl_Position = projectionMatrix * mvpos;
        
                vec2 h = wnoise2(v.xy*3., iTime*.01, .4);
                float hue = (h.x+h.y)/2.;
                col = hsv2rgb(vec3(.36 + .29*hue, 0.8, 0.6)) * fade;
              }`,
            fragmentShader: `
              varying vec3 col;
              uniform vec2 iResolution;
        
              void main() {
                float tex = pow(smoothstep(1., .2, length(2. * gl_PointCoord - 1.)), 3.);
                gl_FragColor = vec4(tex * col, tex );
              }`
          }
        this.starsGeometry = new THREE.BufferGeometry();
        let pointPositions = [];
        let pointSizes = [];
        for ( let i = 0; i < 20000; i ++ ) {
            let x = Math.random();
            let y = Math.random();
            let z = Math.random();
            pointPositions.push( x, y, z );
            pointSizes.push((.7 +.7 * Math.random())*.55);
        }
        this.starsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(pointPositions, 3));
        this.starsGeometry.setAttribute('size', new THREE.Float32BufferAttribute(pointSizes, 1));

        this.stars = new PointPass(null, starsShader, this.starsGeometry, false)
        this.stars.uniforms.iResolution = this.sphereMaterial.uniforms.iResolution
        this.stars.uniforms.iTime = this.sphereMaterial.uniforms.iTime
        this.stars.scene.name = "Stars"

        this.stars.scene.position.set(0, .05, 0)

        this.stars.scene.layers.enable(layers.ENTIRE_SCENE)

        this.sphereGroup.add( this.stars.scene )
    }

    resize() {
        this.sphereMaterial.uniforms['iResolution'].value.x = window.innerWidth * window.devicePixelRatio;
        this.sphereMaterial.uniforms['iResolution'].value.y = window.innerHeight * window.devicePixelRatio;
        
    }

    render__moveIn() {
        this.render__move(
            this.position.hidden,
            this.position.visible,
            () => { this.state.visible = true },
            Ease.OutQuintic,
            1000
        )
    }
    render__moveOut() {
        this.render__move(
            this.position.visible,
            this.position.hidden,
            () => { this.state.visible = false },
            Ease.In
        )
    }
    render__move(from: any, to: any,  onComplete = () => {}, ease = Ease.InCubic, delay = 0, duration = 2000) {
        this.state.changing = true
        dispatchSetChanging(true, 0)
        Tween.to(from, to,
            {
                renderDelay: 10,
                delay,
                duration,
                ease: ease,
                onChange: function(context) {
                    this.instance.position.set(
                        context.value[0], context.value[1], context.value[2]
                    )
                }.bind(this),
                onComplete: function() { 
                    this.state.changing = false 
                    dispatchSetChanging(false)
                    onComplete()
                }.bind(this)
            }
        )
    }

    render({ visible = false }) {
        if ( !this.state.changing ) {
            if ( !visible && this.state.visible ) {
                this.render__moveOut()
            } else
            if ( visible && !this.state.visible ) {
                this.render__moveIn()
            }
        }


        if (this.state.visible || visible) {
            let t = performance.now() / 1000
            this.sphere.rotation.y = 0.15 * t
            this.sphereMaterial.uniforms['iTime'].value = t
            // cornerPass.uniforms[ 'iTime' ].value = t;

    		// this.starsMaterial.uniforms.iTime.value = t
            this.instance.visible = true;
        } else {
            this.instance.visible = false;
        }
    }
}

export default Object8


class BgLight {
    geometry    = null
    material    = null
    instance    = null

    constructor(scene) {
        this.geometry = new THREE.PlaneGeometry( 4.5, 5, 1, 1 )
        this.material = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: .9,
            side: THREE.DoubleSide,
            map: new THREE.TextureLoader().load( lightMap )
        })
        this.instance = new THREE.Mesh( this.geometry, this.material )
        this.instance.scale.set(1.5, 1.5, 1.5)
        this.instance.position.set(0, -3.7, -1)
        this.instance.layers.enable(layers.BLOOM_SCENE)
        scene.add( this.instance )
    }
}